import type { RolodexDocumentEntry } from 'features/files'

/**
 * Types the cantilever-ai document processor produces terminal status for
 * today. Only PDFs are gated: the image processing job is not running on all
 * deployments (images stay `None` forever) and image summaries are not yet
 * consumed downstream, so images must not block the AI banner.
 */
const PROCESSABLE_EXTENSIONS: ReadonlySet<string> = new Set(['pdf'])

export function isUnprocessableDocument(
  doc: Pick<RolodexDocumentEntry, 'file_type' | 'filename'>
): boolean {
  const type = doc.file_type?.toLowerCase()
  if (type && PROCESSABLE_EXTENSIONS.has(type)) return false
  const ext = doc.filename?.toLowerCase().split('.').pop()
  return !(ext && PROCESSABLE_EXTENSIONS.has(ext))
}
